<template>
  <module-configuration :data="config" :errors="errors">
    <div slot="auth" class="l-row">
      <form-group label="Ambiente" :required="true">
        <select v-model="config.auth.environment" class="form-select">
          <option value="sandbox">Sandbox</option>
          <option value="production">Produção</option>
        </select>
      </form-group>
      <form-group label="Token">
        <input class="form-input" v-model="config.auth.token">
      </form-group>
    </div>

    <panel title="Produtos">
      <div class="l-row">
        <product-price-configuration :input="config.product.price"/>
        <form-group label="Redutor de estoque padrão">
          <input class="form-input" min="0" type="number" v-model="config.product.stock.reducer">
        </form-group>
        <form-group label="Máscara de estoque">
          <input class="form-input" min="0" type="number" v-model="config.product.stock.mask">
        </form-group>
      </div>
    </panel>

    <panel :title="$t('expediter.label')">
      <expediter-configuration :expediter="config.order.expediter"/>
    </panel>

    <panel :title="$t('quotation.label')">
      <div class="l-row">
        <div class="l-col-6@md">
          <quotation-configuration :quotation="config.quotation" :marketplace="identifier"/>
        </div>
      </div>
    </panel>

    <panel :title="$t('order.label')">
      <order-retrieve-date-configuration :orderConfigs="config.order"/>
    </panel>

    <panel title="Sincronização">
      <div class="l-row">

        <form-group label="Sincronizar estoque" :columns="3">
          <select class="form-select" v-model="config.synchronize.stock">
            <option v-for="option in synchronizeOptions" :key="option" :value="option">{{$t(`${option}.label`) }}</option>
          </select>
          <small class="form-help">Define se os estoques serão sincronizados e atualizados na Madeira Madeira.</small>
        </form-group>

        <form-group label="Sincronizar preço" :columns="3">
          <select class="form-select" v-model="config.synchronize.price">
            <option v-for="option in synchronizeOptions" :key="option" :value="option">{{$t(`${option}.label`) }}</option>
          </select>
          <small class="form-help">Define se os preços serão sincronizados e atualizados na Madeira Madeira.</small>
        </form-group>

      </div>
    </panel>

  </module-configuration>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ModuleConfiguration from '@/views/Configuration/Shared'
  import FormGroup from '@/components/template/FormGroup'
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'
  import ProductPriceConfiguration from '@/components/shared/ProductPriceConfiguration'
  import ExpediterConfiguration from '@/components/marketplace/shared/ExpediterConfiguration'
  import QuotationConfiguration from '@/components/marketplace/shared/QuotationConfiguration'
  import OrderRetrieveDateConfiguration from '@/components/marketplace/shared/OrderRetrieveDateConfiguration'

  export default {
    inject: ['expeditersDI', 'priceTypeDI', 'quotationDI'],
    provide: {
      moduleDI: {
        type: 'marketplace',
        identifier: 'madeira'
      }
    },
    data: () => ({
      errors: [],
      type: 'marketplace',
      identifier: 'madeira',
      config: {
        auth: {
          environment: 'sandbox',
          token: null,
          referenceCodeStore: null
        },
        product: {
          price: {
            type: null,
            percent: null
          },
          stock: {
            reducer: 0,
            mask: 0
          }
        },
        order: {
          expediter: {
            type: null,
            identifier: null
          },
          retrieveDate: null
        },
        quotation: {
          shipmentMethod: null
        },
        synchronize: {
          stock: true,
          price: true
        }
      },
      synchronizeOptions: [
        true,
        false
      ]
    }),
    watch: {
      'config.product.stock.reducer' (value) {
        this.config.product.stock.reducer = parseInt(value)
      },
      'config.product.stock.mask' (value) {
        this.config.product.stock.mask = parseInt(value)
      }
    },
    computed: {
      ...mapGetters('module', [
        'definitionEcommerceInstalled'
      ])
    },
    components: {
      OrderRetrieveDateConfiguration,
      FormGroup,
      ModuleConfiguration,
      Panel,
      Loader,
      ProductPriceConfiguration,
      ExpediterConfiguration,
      QuotationConfiguration
    }
  }
</script>



// WEBPACK FOOTER //
// Madeira.vue?4502f0f7